import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';
import Spinner from './views/Common/spinner';


function Loading() {
  return <div className="loading-spinner"><Spinner /></div>;
}

const userAdmin = Loadable({
  loader: () => import('./views/User/userAdmin'),
  loading: Loading,
});

const CreateEvent = Loadable({
  loader: () => import('./views/EventList/CreateEvent'),
  loading: Loading,
});

const ViewEvent = Loadable({
  loader: () => import('./views/EventList/ViewEvent'),
  loading: Loading,
});

const EditEvent = Loadable({
  loader: () => import('./views/EventList/EditEvent'),
  loading: Loading,
});

const EventList = Loadable({
  loader: () => import('./views/EventList/EventList'),
  loading: Loading,
});

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading: Loading,
});

const Welcome = Loadable({
  loader: () => import('./views/Drawer/Welcome'),
  loading: Loading,
});

const Biography = Loadable({
  loader: () => import('./views/Drawer/Biography'),
  loading: Loading,
});

const Agenda = Loadable({
  loader: () => import('./views/Drawer/Agenda'),
  loading: Loading,
});

const Feedback = Loadable({
  loader: () => import('./views/Drawer/Feedback'),
  loading: Loading,
});

const Theme = Loadable({
  loader: () => import('./views/Drawer/Theme'),
  loading: Loading,
});




// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Home', component: DefaultLayout, exact: true },
  { path: '/login', name: 'Login', component: Login },
  // { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  // { path: '/eventlist', name: 'EventList', component: EventList },
  // { path: '/createevent', name: 'CreateEvent', component: CreateEvent },
  // { path: '/viewevent', name: 'ViewEvent', component: ViewEvent },
  // { path: '/editevent', name: 'EditEvent', component: EditEvent },
  // { path: '/useradmin', name: 'userAdmin', component: userAdmin },
  // { path: '/welcome', name: 'Welcome', component: Welcome },
  // { path: '/biography', name: 'Biography', component: Biography },
  // { path: '/agenda', name: 'Agenda', component: Agenda },
  // { path: '/feedback', name: 'Feedback', component: Feedback },
  // { path: '/theme', name: 'Theme', component: Theme },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js